import { Navigate } from "react-router-dom";
import { Grid } from "semantic-ui-react";

import LoginForm from "routes/login/Form";
import AuthService from "services/Auth";

const Login = props => {
  return AuthService.isLoggedIn() ? (
    <Navigate to="/" replace />
  ) : (
    <Grid centered verticalAlign="middle" style={{ height: "100vh" }}>
      <Grid.Column style={{ maxWidth: 450 }}>
        <LoginForm {...props} />
      </Grid.Column>
    </Grid>
  );
};

export default Login;
